

import { BannerPageSection, AccordionPageSection, DoctorAdaptiveContent, PageHeaderSection } from "../../sections";
import { contentfulToImageData, getSectionStyling , getContentTypeId} from "../../functions";
import { HEADER_IMAGE_VARIANT, PAGE_SECTION_IDS } from "../../constants";
import LandingPage from "../landing_pages/LandingPage";
import  { ContentfulPageProvider } from "../../context/ContentfulPageContext";

const pageHeaderSectionSysData = {
    "contentType": {
        "sys": {
            "type": "Link",
            "linkType": "ContentType",
            "id": "pageHeaderSection"
        }
    },

}
const TreatmentPageHeaderStyles = {
    "fields": {
        "title": "Landing Page - Page header styling",
        "textAlignment": "Left",
        "mobileTextAlignment": "Left"
    }
}

const formatTreatmentPageData = page => {
	const pageHeader = {
		fields : {
		title : page.fields.title,
		headerText : page.fields.title,
		subtitle : page.fields.subtitle,
		description :page.fields.description,
		nonStaticComponentIds : page.fields.nonStaticComponentIds,
		configurations : [],
		ctas : page.fields.relevantServices,
		images : [page.fields.image],
		displayRelevantServicesMenu : true,
		headerImageDisplayType : HEADER_IMAGE_VARIANT.SEMI_HEART_MASK,
		sectionStyles : TreatmentPageHeaderStyles
		},
		sys : pageHeaderSectionSysData,
		
	}

	const formattedPageSections = page.fields.pageSections?.map(section => {
		const contentType = getContentTypeId(section.sys);
		if(contentType === PAGE_SECTION_IDS.ACCORDION_SECTION){
			return {
				...section,
				fields : {
					...section.fields,
					displayTextType : "NORMAL_TEXT"
				}
			}
		}
		return section
	})
	return {...page, fields : {...page.fields,pageSections : formattedPageSections, pageHeader}}
}


const ConditionsTemplate = ({page, siteStatus, isStatic, parsedFunctions, preload}) => {

	if (!page) return preload ? <div dangerouslySetInnerHTML={{ __html: preload }} /> : null;


	if(!page?.fields) {
		console.warn("No page fields found. Returning null.");
		return null;
	}
	return (<ContentfulPageProvider>
		<TreatmentPageContent
			page={page}
			siteStatus={siteStatus}
			isStatic={isStatic}
			parsedFunctions={parsedFunctions}
			
		/>
	</ContentfulPageProvider>)
}


const TreatmentPageContent = ({ page, siteStatus, isStatic }) => {
	
	const { adaptiveContent, banners, conditionInformation, image , isUsingVersion2} = page.fields;
	const doctorSectionStyles = getSectionStyling(adaptiveContent?.fields?.sectionStyles || {});
	const images = [contentfulToImageData(image)];
	
	const formattedPageData = formatTreatmentPageData(page);

	if(isUsingVersion2){
		return (<LandingPage page={formattedPageData} siteStatus={siteStatus} isStatic={isStatic} />)
	}
	return (
		<main className="contentful-page bg-white">
			<PageHeaderSection
				headerText={page.fields?.title}
				description={page.fields?.description}
				images={images}
				headerImageDisplayType={HEADER_IMAGE_VARIANT.SEMI_HEART_MASK}
				ctas={page.fields.relevantServices}
				displayRelevantServicesMenu={true}
				siteStatus={siteStatus}
				isStatic={isStatic}
			/>
			{adaptiveContent && (
				<DoctorAdaptiveContent
					siteStatus={siteStatus}
					{...adaptiveContent.fields}
					headerText={adaptiveContent?.fields?.headerText || adaptiveContent?.fields?.title}
					formattedSectionStyles={doctorSectionStyles}
				/>
			)}
			{banners &&
				banners.map(({ fields }) => {
					const formattedSectionStyles = getSectionStyling(fields?.sectionStyles || {}, fields?.variant);
					return (
						<BannerPageSection
							key={fields?.title}
							siteStatus={siteStatus}
							{...fields}
							headerText={fields?.headerText || fields?.title}
							formattedSectionStyles={formattedSectionStyles}
						/>
					);
				})}
			{conditionInformation && (
				<AccordionPageSection
					{...conditionInformation.fields}
					headerText={conditionInformation?.fields?.headerText || conditionInformation?.fields?.title}
					siteStatus={siteStatus}
					isStatic={isStatic}
					displayTextType={"AS_PROGRESSIVE_TEXT"}
				/>
			)}
		</main>
	);
};

export default ConditionsTemplate;
